import test from "../assets/images/television/test.webp"
import test2 from "../assets/images/television/2.webp"
import test3 from "../assets/images/television/3.webp"
import test4 from "../assets/images/television/4.webp"
export const televisions = [
    // Samsung TVs
    {
        id: 101,
        name: 'Samsung 55" QLED 4K Smart TV Q60C',
        brand: 'Samsung',
        category: 'Televisions',
        price: 89999,
        originalPrice: 109999,
        discount: 18,
        image:test,
        rating: 4.7,
        reviews: 342,
        screenSize: '55"',
        displayType: 'QLED',
        resolution: '4K',
        smartTv: true,
        os: 'Tizen',
        refreshRate: '60Hz',
        ports: { hdmi: 3, usb: 2 },
        stock: 25,
        emi: 'KSh 3,750/mo',
        kcbOffer: true,
        sales: 1250
    },
    {
        id: 102,
        name: 'Samsung 65" Neo QLED 8K Smart TV QN900C',
        brand: 'Samsung',
        category: 'Televisions',
        price: 349999,
        originalPrice: 399999,
        discount: 12,
        image: test2,
        rating: 4.9,
        reviews: 128,
        screenSize: '65"',
        displayType: 'Neo QLED',
        resolution: '8K',
        smartTv: true,
        os: 'Tizen',
        refreshRate: '120Hz',
        ports: { hdmi: 4, usb: 3 },
        stock: 8,
        emi: 'KSh 14,583/mo',
        kcbOffer: true,
        sales: 450
    },
    {
        id: 103,
        name: 'Samsung 43" Crystal UHD 4K Smart TV CU8000',
        brand: 'Samsung',
        category: 'Televisions',
        price: 54999,
        originalPrice: 64999,
        discount: 15,
        image: test3,
        rating: 4.5,
        reviews: 567,
        screenSize: '43"',
        displayType: 'LED',
        resolution: '4K',
        smartTv: true,
        os: 'Tizen',
        refreshRate: '60Hz',
        ports: { hdmi: 3, usb: 2 },
        stock: 45,
        emi: 'KSh 2,291/mo',
        kcbOffer: false,
        sales: 1890
    },

    // LG TVs
    {
        id: 104,
        name: 'LG 55" OLED evo C3 4K Smart TV',
        brand: 'LG',
        category: 'Televisions',
        price: 189999,
        originalPrice: 219999,
        discount: 14,
        image: test4,
        rating: 4.9,
        reviews: 456,
        screenSize: '55"',
        displayType: 'OLED',
        resolution: '4K',
        smartTv: true,
        os: 'webOS',
        refreshRate: '120Hz',
        ports: { hdmi: 4, usb: 3 },
        stock: 12,
        emi: 'KSh 7,916/mo',
        kcbOffer: true,
        sales: 890
    },
    {
        id: 105,
        name: 'LG 43" UHD 4K Smart TV UR8000',
        brand: 'LG',
        category: 'Televisions',
        price: 49999,
        originalPrice: 59999,
        discount: 17,
        image: test,
        rating: 4.4,
        reviews: 678,
        screenSize: '43"',
        displayType: 'LED',
        resolution: '4K',
        smartTv: true,
        os: 'webOS',
        refreshRate: '60Hz',
        ports: { hdmi: 3, usb: 2 },
        stock: 56,
        emi: 'KSh 2,083/mo',
        kcbOffer: false,
        sales: 2100
    },
    {
        id: 106,
        name: 'LG 75" QNED 80 Series 4K Smart TV',
        brand: 'LG',
        category: 'Televisions',
        price: 249999,
        originalPrice: 289999,
        discount: 14,
        image: test2,
        rating: 4.8,
        reviews: 134,
        screenSize: '75"',
        displayType: 'QNED',
        resolution: '4K',
        smartTv: true,
        os: 'webOS',
        refreshRate: '120Hz',
        ports: { hdmi: 4, usb: 2 },
        stock: 7,
        emi: 'KSh 10,416/mo',
        kcbOffer: true,
        sales: 340
    },

    // Sony TVs
    {
        id: 107,
        name: 'Sony 55" BRAVIA XR A80L OLED 4K TV',
        brand: 'Sony',
        category: 'Televisions',
        price: 219999,
        originalPrice: 249999,
        discount: 12,
        image: test3,
        rating: 4.9,
        reviews: 234,
        screenSize: '55"',
        displayType: 'OLED',
        resolution: '4K',
        smartTv: true,
        os: 'Google TV',
        refreshRate: '120Hz',
        ports: { hdmi: 4, usb: 2 },
        stock: 10,
        emi: 'KSh 9,166/mo',
        kcbOffer: true,
        sales: 560
    },
    {
        id: 108,
        name: 'Sony 65" BRAVIA X80L LED 4K TV',
        brand: 'Sony',
        category: 'Televisions',
        price: 149999,
        originalPrice: 169999,
        discount: 12,
        image: test4,
        rating: 4.7,
        reviews: 345,
        screenSize: '65"',
        displayType: 'LED',
        resolution: '4K',
        smartTv: true,
        os: 'Google TV',
        refreshRate: '60Hz',
        ports: { hdmi: 4, usb: 2 },
        stock: 18,
        emi: 'KSh 6,250/mo',
        kcbOffer: true,
        sales: 890
    },
    {
        id: 109,
        name: 'Sony 43" BRAVIA X75L LED 4K TV',
        brand: 'Sony',
        category: 'Televisions',
        price: 69999,
        originalPrice: 79999,
        discount: 13,
        image: test,
        rating: 4.6,
        reviews: 456,
        screenSize: '43"',
        displayType: 'LED',
        resolution: '4K',
        smartTv: true,
        os: 'Google TV',
        refreshRate: '60Hz',
        ports: { hdmi: 3, usb: 2 },
        stock: 32,
        emi: 'KSh 2,916/mo',
        kcbOffer: false,
        sales: 1120
    },

    // Hisense TVs
    {
        id: 110,
        name: 'Hisense 55" U7K Mini-LED ULED 4K TV',
        brand: 'Hisense',
        category: 'Televisions',
        price: 79999,
        originalPrice: 94999,
        discount: 16,
        image: test2,
        rating: 4.6,
        reviews: 567,
        screenSize: '55"',
        displayType: 'Mini-LED',
        resolution: '4K',
        smartTv: true,
        os: 'VIDAA',
        refreshRate: '144Hz',
        ports: { hdmi: 4, usb: 2 },
        stock: 35,
        emi: 'KSh 3,333/mo',
        kcbOffer: true,
        sales: 1340
    },
    {
        id: 111,
        name: 'Hisense 65" A6K UHD 4K Smart TV',
        brand: 'Hisense',
        category: 'Televisions',
        price: 64999,
        originalPrice: 74999,
        discount: 13,
        image: test3,
        rating: 4.5,
        reviews: 678,
        screenSize: '65"',
        displayType: 'LED',
        resolution: '4K',
        smartTv: true,
        os: 'VIDAA',
        refreshRate: '60Hz',
        ports: { hdmi: 3, usb: 2 },
        stock: 42,
        emi: 'KSh 2,708/mo',
        kcbOffer: false,
        sales: 1780
    },
    {
        id: 112,
        name: 'Hisense 43" A4K FHD Smart TV',
        brand: 'Hisense',
        category: 'Televisions',
        price: 32999,
        originalPrice: 38999,
        discount: 15,
        image: test4,
        rating: 4.3,
        reviews: 890,
        screenSize: '43"',
        displayType: 'LED',
        resolution: 'FHD',
        smartTv: true,
        os: 'VIDAA',
        refreshRate: '60Hz',
        ports: { hdmi: 2, usb: 2 },
        stock: 85,
        emi: 'KSh 1,375/mo',
        kcbOffer: false,
        sales: 3450
    },

    // TCL TVs
    {
        id: 113,
        name: 'TCL 55" C845 Mini LED 4K Google TV',
        brand: 'TCL',
        category: 'Televisions',
        price: 84999,
        originalPrice: 99999,
        discount: 15,
        image: test,
        rating: 4.7,
        reviews: 345,
        screenSize: '55"',
        displayType: 'Mini LED',
        resolution: '4K',
        smartTv: true,
        os: 'Google TV',
        refreshRate: '144Hz',
        ports: { hdmi: 4, usb: 2 },
        stock: 28,
        emi: 'KSh 3,541/mo',
        kcbOffer: true,
        sales: 890
    },
    {
        id: 114,
        name: 'TCL 65" P745 4K UHD Google TV',
        brand: 'TCL',
        category: 'Televisions',
        price: 74999,
        originalPrice: 89999,
        discount: 17,
        image: test2,
        rating: 4.5,
        reviews: 456,
        screenSize: '65"',
        displayType: 'LED',
        resolution: '4K',
        smartTv: true,
        os: 'Google TV',
        refreshRate: '60Hz',
        ports: { hdmi: 3, usb: 2 },
        stock: 36,
        emi: 'KSh 3,125/mo',
        kcbOffer: false,
        sales: 1120
    },
    {
        id: 115,
        name: 'TCL 43" S5400 FHD Android TV',
        brand: 'TCL',
        category: 'Televisions',
        price: 34999,
        originalPrice: 41999,
        discount: 17,
        image: test3,
        rating: 4.4,
        reviews: 678,
        screenSize: '43"',
        displayType: 'LED',
        resolution: 'FHD',
        smartTv: true,
        os: 'Android TV',
        refreshRate: '60Hz',
        ports: { hdmi: 2, usb: 1 },
        stock: 72,
        emi: 'KSh 1,458/mo',
        kcbOffer: false,
        sales: 2340
    },

    // Skyworth TVs
    {
        id: 116,
        name: 'Skyworth 55" SUE9350 4K Google TV',
        brand: 'Skyworth',
        category: 'Televisions',
        price: 49999,
        originalPrice: 59999,
        discount: 17,
        image: test4,
        rating: 4.3,
        reviews: 345,
        screenSize: '55"',
        displayType: 'LED',
        resolution: '4K',
        smartTv: true,
        os: 'Google TV',
        refreshRate: '60Hz',
        ports: { hdmi: 3, usb: 2 },
        stock: 48,
        emi: 'KSh 2,083/mo',
        kcbOffer: false,
        sales: 1230
    },
    {
        id: 117,
        name: 'Skyworth 43" 43STD6500 FHD Android TV',
        brand: 'Skyworth',
        category: 'Televisions',
        price: 29999,
        originalPrice: 34999,
        discount: 14,
        image: test,
        rating: 4.2,
        reviews: 567,
        screenSize: '43"',
        displayType: 'LED',
        resolution: 'FHD',
        smartTv: true,
        os: 'Android TV',
        refreshRate: '60Hz',
        ports: { hdmi: 2, usb: 2 },
        stock: 95,
        emi: 'KSh 1,250/mo',
        kcbOffer: false,
        sales: 3120
    },
    {
        id: 118,
        name: 'Skyworth 32" 32STD6500 HD Android TV',
        brand: 'Skyworth',
        category: 'Televisions',
        price: 18999,
        originalPrice: 22999,
        discount: 17,
        image: test2,
        rating: 4.1,
        reviews: 890,
        screenSize: '32"',
        displayType: 'LED',
        resolution: 'HD',
        smartTv: true,
        os: 'Android TV',
        refreshRate: '60Hz',
        ports: { hdmi: 2, usb: 1 },
        stock: 156,
        emi: 'KSh 791/mo',
        kcbOffer: false,
        sales: 5670
    }
];
